import type { ReactNode } from 'react';

import type { IconNames } from '../../../../uniform/components/text-with-icon/src/icon-mapping';
import type { Meter } from '../context/types';

export type BulletOrIconListItem = {
	icon?: IconNames;
	text: string | ReactNode;
};

export interface FormatPriceOptions {
	currency: string;
	locale: string;
	fractionDigits?: number;
}

export const METER_LABELS: Record<Meter, string> = {
	rovoCredits: 'Rovo Credits',
	automations: 'Automations',
	csResolutions: 'CS Resolutions',
	assetsObjects: 'Assets Objects',
};

export const formatPrice = (price: number, options: FormatPriceOptions): string => {
	const { currency, locale, fractionDigits = 0 } = options;
	return new Intl.NumberFormat(locale, {
		style: 'currency',
		currency,
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: fractionDigits,
	}).format(price);
};
